import axios from 'axios'
import { getHost } from './host'
import { RuleSlice } from '../store/rules/types';

export interface Rule {
  rule_id: number;
  account_id: number;
  title: string;
  description: string;
  category: string;
  station_id: number;
  schedules_id: number;
  status: number;
  created: string;
  updated: string;
  meta: Meta[];
  wrx_option_id: number | null;
}

export interface CreateRule {
  rule_id: number;  
  title: string;
  description: string;
  category: string;
  station_id?: number;
  schedules_id?: number;
  status?: number;
  meta?: Meta[];
  wrx_option_id: null | number;
}

export interface Meta {
  entity: string;
  value: string;
}

// const endPoint = 'api/power';
const endPoint = 'api/rules';

export async function getRules(api_key: string, stations: number[], category) {
  const url = `https://${getHost()}/${endPoint}`
  
  const params = {
    stations: stations,
    category: category
  }

  const { data } = await axios.get<Rule[]>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'}, params: params });
  return data
}

export async function saveRule(api_key: string, account_id=null, rule: CreateRule) {
  var url = `https://${getHost()}/${endPoint}`
  const bodyFormData = new FormData();
  
  if (rule.rule_id !== null) {    
    url = `https://${getHost()}/${endPoint}/`+ rule.rule_id.toString()
  }
  bodyFormData.append('title', rule.title.toString());
  bodyFormData.append('description', rule.description.toString());
  bodyFormData.append('station_id', rule.station_id.toString());
  bodyFormData.append('category', rule.category);
  bodyFormData.append('status', rule.status.toString());
  bodyFormData.append('schedules_id', rule.schedules_id.toString());
  bodyFormData.append('trigger_owasys_refresh', 'true');
  bodyFormData.append('meta', JSON.stringify(rule.meta));   
  
  if (account_id !== null) {
    bodyFormData.append('account_id', account_id);
  }
  
  if (rule.category == 'rawaudio'){
    bodyFormData.append('wrx_option_id', rule.wrx_option_id.toString());
  }  
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<Rule>(url, bodyFormData, { headers: headers });
  
  return data
}

export async function detachStations(api_key: string, station_ids: number[], schedule_id: number, category: string) {
  const url = `https://${getHost()}/${endPoint}/detach`

  const bodyFormData = new FormData();

  station_ids.forEach((station_id) => {
      bodyFormData.append('stations[]', station_id.toString());
  });
  
  bodyFormData.append('schedule_id', schedule_id.toString());
  bodyFormData.append('trigger_owasys_refresh', 'true');
  bodyFormData.append('category', category);
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<any[]>(url, bodyFormData, { headers: headers });
  
  return data
}